<template>
  <div class="d-flex registers justify-content-center general">
    <Registers class="isDesktop" />
    <!-- <Mobile class="isMobile" /> -->
  </div>
</template>

<script>
import Registers from "../../components/Registers/Index-Registers.vue";
// import Mobile from "../../components/Registers/Mobile.vue";
export default {
  components: {
    Registers,
    // Mobile,
  },
};
</script>
<style scoped>
.isMobile {
  display: none !important;
}
@media screen and (max-width: 700px) {
  .isDesktop {
    display: none !important;
  }
  .isMobile {
    display: flex !important;
    flex-direction: column;
  }
}
</style>